<template>
    <div class="page-error container">
        <div class="row  text-center page-error--content">
            <div class="col page-error--img">
                <img src="@/assets/images/icon-error-404.svg">
            </div>
            <div
                class="col page-error--text">
                <h1>No hemos encontrado la página <br> que estás buscando.</h1>
                <p>Al parecer, encontraste un enlace roto.</p>
                <a href="/" class="btn btn-outline__blue btn-white">Volver al inicio</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page404'
}
</script>

<style lang="scss">
[data-scroll-class] {
    opacity: 1;
}

.page-error--content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 100%;
    padding: 3rem 0;

    h1 {
        font-family: $primary-font;
        color: $bg-blue;
        font-size: $large-font-size;
        font-weight: bold;
    }

    p {
        font-size: $medium-font-size;
        margin: 2rem 0;
    }

    // a {        
    //     margin-top: 1rem;
    //     margin-bottom: 5rem;
    // }
}

.page-error--img img {
    height: 100px;
    margin: 2rem;
}

// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
    .page-error--content {
        h1 {
            font-size: $large-font-size;
            max-width: 400px;
            width: 100%;
            margin: 0 auto;
        }

        p {
            font-size: $small-font-size;
            margin-top: 15px;
        }
    }
}
</style>